<template>
  <div>
    <v-dialog v-model="dialogOpen" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-card-text>
          <template v-if="dialogOpen">
            <BroadcastManage
              :value="selectedEditBroadcast"
              :is-save-only="isSaveOnly"
              @onClose="handleCloseDialog"
              @onSave="handleSaveBroadcast"
              @onSent="$emit('onSentBroadcast')"
            ></BroadcastManage>
          </template>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import BroadcastManage from '@/components/view/broadcast/BroadcastManage'

export default {
  components: {
    BroadcastManage
  },
  props: {
    formType: {
      type: String,
      default: 'add'
    },
    open: {
      type: Boolean,
      default: false
    },
    selectedEditItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      dialogOpen: false,
      selectedEditBroadcast: undefined,
      isSaveOnly: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  watch: {
    open(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dialogOpen = this.open
      }
    },
    selectedEditItem: {
      deep: true,
      handler() {
        this.selectedEditBroadcast = this.selectedEditItem
      }
    }
  },
  mounted() {
    if (this.formType === 'edit') {
      this.selectedEditBroadcast = this.selectedEditItem
    }
  },
  methods: {
    handleCloseDialog() {
      this.$emit('onClose')
      this.selectedEditBroadcast = undefined
    },

    handleSaveBroadcast(payload) {
      try {
        this.$emit('onSave', payload)
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/features/tcp/Broadcast/BroadcastManageDialog.vue